<template>
    <router-link to="/challenge/requests" class="challenge-link-requests">
        <span class="challenge-link-requests__heading">İstekler</span>
        <span class="challenge-link-requests__description">Kim buna cüret edebilir?</span>
        <div class="challenge-link-requests__request-data">
            <span
                v-if="showPreloader"
                class="challenge-link-requests__preloader"></span>
            <span
                v-if="!showPreloader"
                class="challenge-link-requests__request-count">{{ numRequests }} İSTEK</span>
        </div>
        <span class="challenge-link-requests__deco-triangle"></span>
        <span class="challenge-link-requests__deco-mailbox"></span>
    </router-link>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        data(){
            return {
                showPreloader: false,
            };
        },

        computed: {
            numRequests(){
                return this.$store.state.response.challenge.challengeRequests.length;
            },
        },

        mounted(){
            if(this.$store.state.envDev){

            }
            else{
                this.showPreloader = true;
                fetch(this.$store.state.api.challengeRequestAll, {
                    method: 'GET',
                    credentials: 'include',
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(challengeRequests => {
                    this.$store.commit('setResponseChallengeChallengeRequests', challengeRequests);
                    this.showPreloader = false;
                })
                .catch(err => {
                    if(err.code === 'CHALLENGE_REQUEST_ALL_MODEL/REQUEST_ALL::INV_USER_SESSION'){
                        this.$foneturkError({
                            text: this.$t(`error.api.challengeRequestAll.${err.code}`),
                            didClose: () => {
                                // this.$router.push('/login');
                            }
                        });
                    }
                    else{
                        this.$foneturkError({
                            text: this.$t(`error.default`)
                        });
                    }
                });
            }
        }
    };
</script>

<style scoped src="@/css/components/challenge-link-requests.css"></style>